import React from "react";
import { Container } from "reactstrap";
import flipoLogo from "../../assets/FLIPO_Logo.svg";

const Header: React.FC = () => {
  return (
    <>
      {/* Logo Section */}
      <Container style={styles.logoContainer}>
        <img src={flipoLogo} alt="FLIPO Logo" style={styles.logo} />
      </Container>
    </>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  logoContainer: {
    textAlign: "center",
    padding: "15px 0",
    backgroundColor: "#FFFFFF",
  },
  logo: {
    maxWidth: "180px",
    height: "auto",
  },
};

export default Header;

